import { FC, ReactElement } from 'react';

import { ImagePreviewDialog } from '../dialog';
import { useImagePreviewService } from '../service';

export const ImagePreviewProvider: FC<{ children: ReactElement }> = ({ children }) => {
  const { config, closePreview } = useImagePreviewService();

  return (
    <>
      {children}
      {config && <ImagePreviewDialog open={config.open} src={config.src} alt={config.alt} onClose={closePreview} />}
    </>
  );
};
